import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import { customReportPropTypes } from './propTypes';

import {
  showCustomReportFormForEdit,
  showCustomReportModalForDelete,
} from '../../administration/customReportsManagementPage/store/actions';

class CustomReportsAdminColumnRenderer extends PureComponent {
  static propTypes = {
    data: customReportPropTypes.isRequired,
    showCustomReportFormForEdit: PropTypes.func.isRequired,
    showCustomReportModalForDelete: PropTypes.func.isRequired,
  };

  showCustomReportFormForEdit = () => {
    const { data, showCustomReportFormForEdit } = this.props;

    showCustomReportFormForEdit(data.reportSetId);
  };

  showCustomReportModalForDelete = () => {
    const { data, showCustomReportModalForDelete } = this.props;

    showCustomReportModalForDelete({
      id: data.reportSetId,
      name: data.reportSetName,
    });
  };

  render() {
    return (
      <div>
        <button
          className="cell-icon-button"
          title="Edit Custom Report"
          onClick={this.showCustomReportFormForEdit}
        >
          <PencilIcon size={16} className="cell-icon" />
        </button>
        <button
          className="cell-icon-button"
          title="Delete Custom Report"
          onClick={this.showCustomReportModalForDelete}
        >
          <TrashIcon size={16} className="cell-icon" />
        </button>
      </div>
    );
  }
}

export default connect(null, {
  showCustomReportFormForEdit,
  showCustomReportModalForDelete,
})(CustomReportsAdminColumnRenderer);
